import axios from "axios";

const fetchDelete = () => {
  const defaultOptions = {
    baseURL: "",
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };

  // Create instance
  let instance = axios.create(defaultOptions);

  instance.interceptors.request.use(function (config) {
    const token = localStorage.getItem("API_TOKEN");
    config.headers.Authorization = token ? `Bearer ${token}` : "";
    console.log(config, "check");
    return config;
  });

  return instance;
};

export default fetchDelete();
